const getCssVariable = variable => {
  return getComputedStyle(document.documentElement)
    .getPropertyValue(variable)
    .trim();
};

export default getCssVariable;
